import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconAlertInfoFilled,
	homefieldIconAlertWarningFilled
} from '@dsg-tech/homefield-angular-icons';

import { AlertMessageComponent } from './alert-message.component';
import { CommonModule } from '@angular/common';
import { HtmlSanitizerPipe } from '@shared/utils/pipes';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [
		AlertMessageComponent
	],
	imports: [
		CommonModule,
		HomefieldIconLibraryModule,
		HtmlSanitizerPipe,
	],
	exports: [
		AlertMessageComponent
	]
})
export class AlertMessageModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconAlertInfoFilled,
			homefieldIconAlertWarningFilled]);
	}
}
